import { WeakObject } from "../utils/WeakObject";
export class UIUtils {
    static fillArray(arr, str, type = null) {
        let temp = arr.concat();
        if (str) {
            let a = str.split(",");
            for (let i = 0, n = Math.min(temp.length, a.length); i < n; i++) {
                let value = a[i];
                temp[i] = (value == "true" ? true : (value == "false" ? false : value));
                if (type != null)
                    temp[i] = type(value);
            }
        }
        return temp;
    }
    static getBindFun(value) {
        if (!UIUtils._funMap) {
            UIUtils._funMap = new WeakObject();
        }
        var fun = UIUtils._funMap.get(value);
        if (fun == null) {
            var temp = "\"" + value + "\"";
            temp = temp.replace(/^"\${|}"$/g, "").replace(/\${/g, "\"+").replace(/}/g, "+\"");
            var str = "(function(data){if(data==null)return;with(data){try{\nreturn " + temp + "\n}catch(e){}}})";
            fun = window.Laya._runScript(str);
            UIUtils._funMap.set(value, fun);
        }
        return fun;
    }
}
UIUtils._funMap = null;
